// Start cards Images imports
import TouchImage from '../assets/images/Categories/leg-massage.png';
import MindRelaxImage from '../assets/images/Categories/mind-relax.png';
import BeautyImage from '../assets/images/Categories/facial.png';
import HealthImage from '../assets/images/Categories/nawarakizhi-1.png';
import LuxuriousImage from '../assets/images/Categories/shirodara.png';
// End cards Images imports

// Start title descriptions
let soundTitleDescription = "Sounds are powerful tools for emotional and mental well-being. From the soothing waves of the ocean to the powerful rumbles of thunder, soundscapes have the ability to calm the mind, evoke energy, or connect us with nature's rhythm."
let FragranceTitleDescription = "Fragrances have a profound effect on our emotions and energy. Aromas like citrus or rosemary can uplift the spirit, while floral scents like neroli help soothe the mind. Each fragrance offers a unique way to enhance moods and create a sensory atmosphere."
let lightTitleDescription = "Lights influence our mood and energy, shaping the atmosphere of a space. Whether it's the calming glow of soft hues or the invigorating brightness of vibrant tones, light can create an environment that enhances relaxation, creativity, or focus."
// End title descriptions

// Start sounds Images imports
import WaterFlowingImage from '../assets/icons/CategoryItems/Sound/water-flowing-sound-2.jpg';
import BirdsChirpingImage from '../assets/icons/CategoryItems/Sound/birds-sound-1.jpg';
import FluteImage from '../assets/icons/CategoryItems/Sound/flute-sound-1.jpg';
import GayathriMantraImage from '../assets/icons/CategoryItems/Sound/gayathri-mantra-sound-1.jpg';
import DhanvantariMantraImage from '../assets/icons/CategoryItems/Sound/dhanvantari-mantra-sound-1.jpg';
import SitarImage from '../assets/icons/CategoryItems/Sound/sitar-sound-1.jpg';
import OceanImage from '../assets/icons/CategoryItems/Sound/ocean-sound-1.jpg';
import ThunderImage from '../assets/icons/CategoryItems/Sound/thunder-sound-1.jpg';
import ForestStreamImage from '../assets/icons/CategoryItems/Sound/forest-stream-sound-1.jpg';
// End sounds Images imports

// Start fragrances Images imports
import LavenderImage from '../assets/icons/CategoryItems/Fragrance/lavender-fragrance-1.jpg';
import SandalwoodImage from '../assets/icons/CategoryItems/Fragrance/sandalwood-fragrance-1.jpg';
import JasmineImage from '../assets/icons/CategoryItems/Fragrance/jasmine-fragrance-1.jpg';
import RoseImage from '../assets/icons/CategoryItems/Fragrance/rose-fragrance-1.jpg';
import FrankincenseImage from '../assets/icons/CategoryItems/Fragrance/frankincense-fragrance-1.jpg';
import EucalyptusImage from '../assets/icons/CategoryItems/Fragrance/eucalyptus-fragrance-1.jpg';
import CitrusImage from '../assets/icons/CategoryItems/Fragrance/citrus-fragrance-1.jpg';
import RosemaryImage from '../assets/icons/CategoryItems/Fragrance/rosemary-fragrance-1.jpg';
import NeroliImage from '../assets/icons/CategoryItems/Fragrance/neroli-fragrance-1.jpg';
// End fragrances Images imports

// Start light Images imports
import BlueLightImage from '../assets/icons/CategoryItems/Light/blue-1.jpg';
import GreenLightImage from '../assets/icons/CategoryItems/Light/green-1.jpg';
import BrownLightImage from '../assets/icons/CategoryItems/Light/brown-1.jpg';
import WhiteLightImage from '../assets/icons/CategoryItems/Light/white-1.jpg';
import GreyLightImage from '../assets/icons/CategoryItems/Light/grey-1.jpg';
import PurpleLightImage from '../assets/icons/CategoryItems/Light/purple-1.jpg';
import GoldLightImage from '../assets/icons/CategoryItems/Light/gold-1.jpg';
import CreamLightImage from '../assets/icons/CategoryItems/Light/cream-1.jpg';
// End fragrances Images imports

// Start sounds data
const waterFlowingSoundData = {
    equipmentItemId: 1,
    equipmentItemName: "Water flowing",
    equipmentItemSubtitle: "A gentle cascade of tranquility.",
    equipmentItemDescription: "The sound of flowing water mirrors nature's rhythm, washing away stress and fostering a deep sense of calm and rejuvenation.",
    equipmentItemImage: WaterFlowingImage,
    alt: "Water flowing sound image"
};

const BirdsChirpingSoundData = {
    equipmentItemId: 2,
    equipmentItemName: "Birds chirping",
    equipmentItemSubtitle: "The harmonious symphony of nature's dawn.",
    equipmentItemDescription: "The gentle chirping of birds brings a sense of serenity and joy, connecting you to the essence of nature and promoting inner peace.",
    equipmentItemImage: BirdsChirpingImage,
    alt: "birds chirping sound image"
};

const fluteMelodySoundData = {
    equipmentItemId: 3,
    equipmentItemName: "Flute melody",
    equipmentItemSubtitle: "A whisper of calm in a chaotic world.",
    equipmentItemDescription: "The soothing sound of the flute resonates with the soul, easing stress and enhancing mental clarity.",
    equipmentItemImage: FluteImage,
    alt: "flute melody sound image"
};

const gayathriMantraSoundData = {
    equipmentItemId: 4,
    equipmentItemName: "Gayathri Mantra",
    equipmentItemSubtitle: "A chant that awakens the divine within.",
    equipmentItemDescription: "The Gayathri Mantra carries profound vibrations that calm the mind, rejuvenate the spirit, and align your inner energy.",
    equipmentItemImage: GayathriMantraImage,
    alt: "flute melody sound image"
};

const sitarSoundData = {
    equipmentItemId: 5,
    equipmentItemName: "Sitar Sound",
    equipmentItemSubtitle: "Strings of harmony and mindfulness.",
    equipmentItemDescription: "The melodious sound of the sitar fosters deep relaxation, enhances focus, and connects you to the spiritual essence of music.",
    equipmentItemImage: SitarImage,
    alt: "sitar sound image",
};

const dhanvantariMantraData = {
    equipmentItemId: 6,
    equipmentItemName: "Dhanvantari Mantra",
    equipmentItemSubtitle: "A chant for health and vitality.",
    equipmentItemDescription: "The Dhanvantari Mantra invokes the blessings of the divine healer, promoting physical and spiritual well-being through its healing vibrations.",
    equipmentItemImage: DhanvantariMantraImage,
    alt: "dhanvantari mantra image",
};

const oceanSoundData = {
    equipmentItemId: 7,
    equipmentItemName: "Ocean",
    equipmentItemSubtitle: "Waves of serenity and vastness.",
    equipmentItemDescription: "The rhythmic sound of ocean waves calms the mind, inspiring a deep sense of peace and connection to nature.",
    equipmentItemImage: OceanImage,
    alt: "ocean sound image",
};

const thunderSoundData = {
    equipmentItemId: 8,
    equipmentItemName: "Thunder",
    equipmentItemSubtitle: "The powerful roar of nature's energy.",
    equipmentItemDescription: "Thunder's deep rumble evokes awe and introspection, channeling the raw strength of the elements.",
    equipmentItemImage: ThunderImage,
    alt: "thunder sound image",
};

const forestStreamsSoundData = {
    equipmentItemId: 9,
    equipmentItemName: "Forest Streams",
    equipmentItemSubtitle: "A gentle murmur of nature's vitality.",
    equipmentItemDescription: "The sound of forest streams soothes the senses, enhancing relaxation and evoking a connection to the wilderness.",
    equipmentItemImage: ForestStreamImage,
    alt: "forest streams sound image",
};
// End sounds data

// Start fragrances data
const lavenderFragranceData = {
    equipmentItemId: 1,
    equipmentItemName: "Lavender",
    equipmentItemSubtitle: "A floral embrace for your senses.",
    equipmentItemDescription: "Lavender's soothing aroma promotes relaxation, reduces stress, and encourages a restful state of mind, making it perfect for calming rituals.",
    equipmentItemImage: LavenderImage,
    alt: "lavender fragrance image"
};

const sandalwoodFragranceData = {
    equipmentItemId: 2,
    equipmentItemName: "Sandalwood",
    equipmentItemSubtitle: "Earthy and divine, a timeless essence.",
    equipmentItemDescription: "Sandalwood's warm, woody fragrance enhances meditation, fosters tranquility, and grounds the spirit with its sacred aroma.",
    equipmentItemImage: SandalwoodImage,
    alt: "sandalwood fragrance image"
};

const jasmineFragranceData = {
    equipmentItemId: 3,
    equipmentItemName: "Jasmine",
    equipmentItemSubtitle: "The queen of the night in bloom.",
    equipmentItemDescription: "Jasmine's intoxicating scent uplifts the mood, inspires confidence, and creates an atmosphere of sensuality and peace.",
    equipmentItemImage: JasmineImage,
    alt: "jasmine fragrance image"
};

const roseFragranceData = {
    equipmentItemId: 4,
    equipmentItemName: "Rose",
    equipmentItemSubtitle: "The timeless essence of love and beauty.",
    equipmentItemDescription: "Rose fragrance exudes a romantic and soothing aroma, enhancing emotional well-being and fostering a sense of calm and connection.",
    equipmentItemImage: RoseImage,
    alt: "rose fragrance image",
};

const frankincenseFragranceData = {
    equipmentItemId: 5,
    equipmentItemName: "Frankincense",
    equipmentItemSubtitle: "A sacred aroma of calm and clarity.",
    equipmentItemDescription: "Frankincense fragrance fosters a sense of spiritual connection, relieves stress, and creates a peaceful and meditative atmosphere.",
    equipmentItemImage: FrankincenseImage,
    alt: "frankincense fragrance image",
};

const eucalyptusFragranceData = {
    equipmentItemId: 6,
    equipmentItemName: "Eucalyptus",
    equipmentItemSubtitle: "A breath of revitalizing freshness.",
    equipmentItemDescription: "Eucalyptus fragrance refreshes the senses, clears the mind, and promotes respiratory well-being with its cool, invigorating scent.",
    equipmentItemImage:EucalyptusImage,
    alt: "eucalyptus fragrance image",
};

const citrusFragranceData = {
    equipmentItemId: 7,
    equipmentItemName: "Citrus",
    equipmentItemSubtitle: "A zesty burst of freshness.",
    equipmentItemDescription: "Citrus fragrance invigorates the senses, lifting the mood and promoting energy and focus with its bright and tangy aroma.",
    equipmentItemImage: CitrusImage,
    alt: "citrus fragrance image",
};

const rosemaryFragranceData = {
    equipmentItemId: 8,
    equipmentItemName: "Rosemary",
    equipmentItemSubtitle: "An herbaceous scent of clarity.",
    equipmentItemDescription: "Rosemary's fresh, woody aroma enhances mental clarity, improves focus, and rejuvenates the mind and body.",
    equipmentItemImage: RosemaryImage,
    alt: "rosemary fragrance image",
};

const neroliFragranceData = {
    equipmentItemId: 9,
    equipmentItemName: "Neroli",
    equipmentItemSubtitle: "A floral whisper of elegance.",
    equipmentItemDescription: "Neroli's sweet, citrusy floral scent calms the nerves, uplifts the spirit, and creates a serene, luxurious atmosphere.",
    equipmentItemImage: NeroliImage,
    alt: "neroli fragrance image",
};
// End fragrances data

// Start light data
const blueLightData = {
    equipmentItemId: 1,
    equipmentItemName: "Blue",
    equipmentItemSubtitle: "A calming embrace of the infinite.",
    equipmentItemDescription: "Blue light evokes feelings of serenity and trust, like the vast sky and the deep ocean.",
    equipmentItemImage: BlueLightImage,
    alt: "blue light image",
};

const greenLightData = {
    equipmentItemId: 2,
    equipmentItemName: "Green",
    equipmentItemSubtitle: "A symbol of growth and harmony.",
    equipmentItemDescription: "Green light represents growth and harmony, evoking a sense of balance and renewal.",
    equipmentItemImage: GreenLightImage,
    alt: "green light image",
};

const brownLightData = {
    equipmentItemId: 3,
    equipmentItemName: "Brown",
    equipmentItemSubtitle: "The color of stability and warmth.",
    equipmentItemDescription: "Brown light symbolizes stability and connection to the earth, fostering a grounded and comforting atmosphere.",
    equipmentItemImage: BrownLightImage,
    alt: "brown light image",
};

const whiteLightData = {
    equipmentItemId: 4,
    equipmentItemName: "White",
    equipmentItemSubtitle: "A pure glow of clarity and peace.",
    equipmentItemDescription: "White light symbolizes purity, clarity, and unity, promoting a sense of balance and spiritual alignment.",
    equipmentItemImage: WhiteLightImage,
    alt: "white light image",
};

const greyLightData = {
    equipmentItemId: 5,
    equipmentItemName: "Grey",
    equipmentItemSubtitle: "A subtle tone of balance and composure.",
    equipmentItemDescription: "Grey light embodies neutrality and calm, creating an atmosphere of reflection and understated elegance.",
    equipmentItemImage: GreyLightImage,
    alt: "grey light image",
};

const purpleLightData = {
    equipmentItemId: 6,
    equipmentItemName: "Purple",
    equipmentItemSubtitle: "A regal glow of mystery and inspiration.",
    equipmentItemDescription: "Purple light stimulates creativity and imagination while evoking a sense of luxury and introspection.",
    equipmentItemImage: PurpleLightImage,
    alt: "purple light image",
};

const goldLightData = {
    equipmentItemId: 7,
    equipmentItemName: "Gold",
    equipmentItemSubtitle: "A radiant hue of prosperity and warmth.",
    equipmentItemDescription: "Gold light represents abundance and energy, uplifting the spirit and creating a sense of celebration.",
    equipmentItemImage: GoldLightImage,
    alt: "gold light image",
};

const creamLightData = {
    equipmentItemId: 8,
    equipmentItemName: "Cream",
    equipmentItemSubtitle: "A gentle shade of elegance and comfort.",
    equipmentItemDescription: "Cream light offers a soothing and inviting ambiance, perfect for fostering relaxation and tranquility.",
    equipmentItemImage: CreamLightImage,
    alt: "cream light image",
};
// End light data

const CategoriesData = [
    // Start Mind Relax
    {
        id: 1,
        title: "Mind Relax",
        subtitle: "Experiences for Inner Peace",
        description:
            "Unwind and clear your mind with treatments designed to reduce stress and promote mental calmness. Bring peace to your mind.",
        alt: "Head Massage Image",
        src: MindRelaxImage,
        equipment: [
            // Start sound
            {
                equipmentId: 1,
                equipmentName: "Sound",
                description: soundTitleDescription,
                equipmentItem: [
                    waterFlowingSoundData,
                    BirdsChirpingSoundData,
                    fluteMelodySoundData,
                ]
            },
            // End sound

            // Start fragrance
            {
                equipmentId: 2,
                equipmentName: "Fragrance",
                description: FragranceTitleDescription,
                equipmentItem: [
                    lavenderFragranceData,
                    sandalwoodFragranceData,
                    jasmineFragranceData,
                ]
            },
            // End fragrance

            // Start light
            {
                equipmentId: 3,
                equipmentName: "Light",
                description: lightTitleDescription,
                equipmentItem: [
                    blueLightData,
                    greenLightData,
                    brownLightData,
                ]
            },
            //End light
        ],
    },
    // End Mind Relax

    // Start Beauty
    {
        id: 2,
        title: "Beauty",
        subtitle: "Rejuvenating Beauty Rituals",
        description:
            "Reveal your natural beauty with treatments tailored to rejuvenate your skin, hair, and body, enhancing your radiance and bringing out your best self.",
        alt: "Face Facial Image",
        src: BeautyImage,
        equipment: [
            // Start Mind Relax sound
            {
                equipmentId: 1,
                equipmentName: "Sound",
                description: soundTitleDescription,
                equipmentItem: [
                    waterFlowingSoundData,
                    BirdsChirpingSoundData,
                    gayathriMantraSoundData,
                ]
            },
            // End sound

            // Start Mind Relax fragrance
            {
                equipmentId: 2,
                equipmentName: "Fragrance",
                description: FragranceTitleDescription,
                equipmentItem: [
                    lavenderFragranceData,
                    sandalwoodFragranceData,
                    roseFragranceData,
                ]
            },
            // End fragrance

            // Start Mind Relax light
            {
                equipmentId: 3,
                equipmentName: "Light",
                description: lightTitleDescription,
                equipmentItem: [
                    greenLightData,
                    whiteLightData,
                    brownLightData
                ]
            },
        ],
    },
    // End Beauty

    // Start Health
    {
        id: 3,
        title: "Health",
        subtitle: "Healing & Renewal Treatments",
        description:
            "Rejuvenate your body with therapeutic treatments that enhance your overall well-being, boost energy, and restore balance for vitality and wellness.",
        alt: "Body Massage Image",
        src: HealthImage,
        equipment: [
            // Start Health sound
            {
                equipmentId: 1,
                equipmentName: "Sound",
                description: soundTitleDescription,
                equipmentItem: [
                    sitarSoundData,
                    fluteMelodySoundData,
                    dhanvantariMantraData,
                ]
            },
            // End sound

            // Start Health fragrance
            {
                equipmentId: 2,
                equipmentName: "Fragrance",
                description: FragranceTitleDescription,
                equipmentItem: [
                    frankincenseFragranceData,
                    roseFragranceData,
                    eucalyptusFragranceData,
                ]
            },
            // End fragrance

            // Start Health light
            {
                equipmentId: 3,
                equipmentName: "Light",
                description: lightTitleDescription,
                equipmentItem: [
                    brownLightData,
                    greenLightData,
                    whiteLightData,

                ]
            },
        ],
    },
    // End Health

    // Start  Touch
    {
        id: 4,
        title: "Touch",
        subtitle: "Deep Tissue Treatments",
        description:
            "Embrace the healing power of touch through therapies that relieve tension, restore balance, and promote deep relaxation, connecting you with pure serenity.",
        alt: "Body Massage Image",
        src: TouchImage,
        equipment: [
            // Start Touch sound
            {
                equipmentId: 1,
                equipmentName: "Sound",
                description: soundTitleDescription,
                equipmentItem: [
                    oceanSoundData,
                    thunderSoundData,
                    forestStreamsSoundData,
                ]
            },
            // End sound

            // Start Touch fragrance
            {
                equipmentId: 2,
                equipmentName: "Fragrance",
                description: FragranceTitleDescription,
                equipmentItem: [
                    eucalyptusFragranceData,
                    citrusFragranceData,
                    rosemaryFragranceData,
                ]
            },
            // End fragrance

            // Start Touch light
            {
                equipmentId: 3,
                equipmentName: "Light",
                description: lightTitleDescription,
                equipmentItem: [
                    brownLightData,
                    greenLightData,
                    greyLightData,
                ]
            },
        ],
    },
    // End Touch

    // Start Luxurious Experience
    {
        id: 5,
        title: "Luxurious Experience",
        subtitle: "Premium Indulgence",
        description:
            "Indulge in lavish treatments that elevate your senses, pampering you with the finest products and techniques for an opulent escape.",
        alt: "Massage Image",
        src: LuxuriousImage,
        equipment: [
            // Start Luxurious Experience sound
            {
                equipmentId: 1,
                equipmentName: "Sound",
                description: soundTitleDescription,
                equipmentItem: [
                    sitarSoundData,
                    fluteMelodySoundData,
                    BirdsChirpingSoundData,
                ]
            },
            // End sound

            // Start Luxurious Experience fragrance
            {
                equipmentId: 2,
                equipmentName: "Fragrance",
                description: FragranceTitleDescription,
                equipmentItem: [
                    jasmineFragranceData,
                    sandalwoodFragranceData,
                    neroliFragranceData,
                ]
            },
            // End fragrance

            // Start Luxurious Experience light
            {
                equipmentId: 3,
                equipmentName: "Light",
                description: lightTitleDescription,
                equipmentItem: [
                    purpleLightData,
                    goldLightData,
                    creamLightData,
                ]
            },
        ],
    },
    // End Luxurious Experience
];

export default CategoriesData;